import { Cache } from "memory-cache";
import { CorporationIndustryJobEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCorporationIndustryJobEntity(
  job_id: number
): Promise<CorporationIndustryJobEntity | null> {
  let entity: any = await cache.get(job_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCorporationIndustryJobEntity(corporationIndustryJob: CorporationIndustryJobEntity) {
  cache.put(corporationIndustryJob.props.job_id.toString(), corporationIndustryJob, 5 * 60 * 1000 /* 5 mins */);
}
